import { useState } from 'react';
import { IconButton, Popover, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export function ShowActionPopup({ rowId, type, onActionClick, options=["Search Similar", "Search Agent Suite", "View Incident"] }: {
  rowId: string;
  type?: string;
  onActionClick: (rowId: string, type: string) => void;
  options?: string[];
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Generate actionHandlers dynamically from options
  const generateActionHandlers = () => {
    const handlers = {};
    
    options.forEach(option => {
      // E.g. this converts "Search Agent" to "searchAgent"
      // In your rendition of 'onActionClick' decide what to do with this
      const type = option.split(' ')
        .map((word, index) => {
          if (index === 0) {
            return word.toLowerCase();
          }
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join('');
      
      handlers[option] = () => {
        console.log(`Action clicked ${option}`);
        onActionClick(rowId, type);
        handleClose();
      };
    });
    
    return handlers;
  };
  
  const actionHandlers = generateActionHandlers();
  
  const open = Boolean(anchorEl);
  const id = open ? `popover-${rowId}` : undefined;

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            onClick={actionHandlers[option] || (() => console.debug("No action handler for this option"))}
          >
            {option}
          </MenuItem>
        ))}
      </Popover>
    </>
  );
}
